import React, { useState, useEffect } from 'react';
import Layout from '@/common/Layout';
import {
  Row,
  Col,
  Form,
  Card,
  // Select,
  Input,
  // DatePicker,
  Space,
  message,
  Image,
  Spin,
  Modal,
  Tooltip
} from 'antd';
import styles from '@/common/Layout/index.module.less';
import FormItem from '@/common/FormItem';
import {
  createlog,
  discardBatch,
  getAllLogBooksdetails,
  printLogDetails
} from '../../redux/slice';
import { useDispatch } from 'react-redux';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import truck from '@/features/generateMrn/components/images/truck-delivery-done.gif';
import {
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { FilePdfOutlined } from '@ant-design/icons';

// const { TextArea } = Input;

const ViewEditLog = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const params = useParams();

  const [truckShow, setTruckShow] = useState(false);
  const [alllogs, setAlllogs] = useState([]);
  const [enableCard, setEnableCard] = useState();
  const [editedLogs, setEditedLogs] = useState([]);
  const [hidePrint, setHidePrint] = useState(false);

  useEffect(() => {
    handleGetAllLogDetails();
  }, []);

  const handleGetAllLogDetails = () => {
    const payload = { batch_log_id: params?.id };
    dispatch(getAllLogBooksdetails(payload)).then((response) => {
      if (response?.payload?.success) {
        setAlllogs(response?.payload?.data);
      }
    });
  };

  const handleOnChange = (e, id, index, j, type, main_type, wip_id, i) => {
    let list = [...alllogs];
    if (main_type == 'main') {
      list[index][type] = e.target.value;
    }
    if (main_type == 'wip') {
      list[index].wip_batch_nums[j][type] = e.target.value;
    }
    if (main_type == 'fg') {
      list[index].wip_batch_nums[j].fg_batch_nums[i][type] = e.target.value;
    }
    // The edit buffer always holds exactly ONE row (built by `handleEnable` for the
    // section currently in edit mode). All writes must target row 0 — not `index`,
    // which is the blend's position in the displayed list and has nothing to do
    // with the buffer.
    let editableRows = [...editedLogs];
    if (!editableRows[0]) editableRows[0] = {};

    if (type == 'wip_size') {
      const wipSize = parseFloat(e.target.value);
      const blendSize = parseFloat(list[index].blend_size);
      let blendAllocWip;
      if (
        Number.isFinite(wipSize) &&
        Number.isFinite(blendSize) &&
        blendSize > 0
      ) {
        // Two-decimal precision avoids the historical truncation bug where 16.67 got
        // saved as 16 and downstream cost reports lost ~1% per allocation event.
        blendAllocWip = ((wipSize / blendSize) * 100).toFixed(2);
      } else {
        blendAllocWip = '';
      }
      list[index].wip_batch_nums[j].blend_alloc_wip = blendAllocWip;
      editableRows[0]['blend_alloc_wip'] = blendAllocWip;
    }
    if (type == 'fg_alloc_capsules') {
      const fgCaps = parseFloat(e.target.value);
      const wipCaps = parseFloat(list[index].wip_batch_nums[j].wip_size_caps);
      // Read blend_alloc_wip with parseFloat (NOT parseInt) so the cascading auto-calc
      // for blend_alloc_fg inherits decimal precision rather than re-truncating.
      const blendAllocWip = parseFloat(
        list[index].wip_batch_nums[j].blend_alloc_wip
      );
      let wipAllocFg;
      let blendAllocFg;
      if (Number.isFinite(fgCaps) && Number.isFinite(wipCaps) && wipCaps > 0) {
        wipAllocFg = ((fgCaps / wipCaps) * 100).toFixed(2);
        if (Number.isFinite(blendAllocWip)) {
          blendAllocFg = ((fgCaps / wipCaps) * blendAllocWip).toFixed(2);
        } else {
          blendAllocFg = '';
        }
      } else {
        wipAllocFg = '';
        blendAllocFg = '';
      }
      list[index].wip_batch_nums[j].fg_batch_nums[i].wip_alloc_fg = wipAllocFg;
      list[index].wip_batch_nums[j].fg_batch_nums[i].blend_alloc_fg =
        blendAllocFg;
      editableRows[0]['wip_alloc_fg'] = wipAllocFg;
      editableRows[0]['blend_alloc_fg'] = blendAllocFg;
    }
    setAlllogs(list);

    editableRows[0][type] = e.target.value;

    setEditedLogs(editableRows);
  };

  const onFinish = (values) => {
    setTruckShow(true);
    const payload = {
      blend_batch: values?.blend_batch,
      blend_size: values?.blend_size,
      blend_bmr: values?.bmr,
      alloted_by: values?.alloted_by
      // batch_wip: wipDetails
    };
    dispatch(createlog(payload)).then((response) => {
      if (response?.payload?.success) {
        setTruckShow(false);
        message.success(response?.payload?.message);
        history.push('/log-book-list');
      }
    });
  };

  const handleUpdate = async () => {
    // Guard: button can be clicked while a save is in flight (e.g. via keyboard
    // or rapid double-click) — bail out so we never fire duplicate API calls.
    if (truckShow) return;

    const source = editedLogs[0] || {};

    // Build the payload IMMUTABLY — strip null/undefined keys, keep the rest.
    // The previous version did `delete editedLogs[0][key]` which mutated the
    // React state object directly. After one save, that object was permanently
    // stripped, so a subsequent click would send an effectively-empty payload
    // and the backend update would be a no-op ("update is not happening").
    const payload = Object.entries(source).reduce((acc, [k, v]) => {
      if (v !== null && v !== undefined) acc[k] = v;
      return acc;
    }, {});

    // Sanity check — payload must contain at least one editable field,
    // not just the IDs (blend_id / wip_id / fg_id).
    const idKeys = ['blend_id', 'wip_id', 'fg_id'];
    const editableFieldCount = Object.keys(payload).filter(
      (k) => !idKeys.includes(k)
    ).length;
    if (editableFieldCount === 0) {
      message.warning('No changes to save.');
      return;
    }

    setTruckShow(true);
    try {
      const response = await dispatch(createlog(payload));
      if (response?.payload?.success) {
        message.success(response?.payload?.message || 'Updated successfully.');
        // Re-fetch the record so the form shows the saved values immediately.
        // Previously this called `history.push(<same URL>)` which does NOT
        // re-mount or re-fetch in React Router, leaving the page on stale state.
        handleGetAllLogDetails();
        setEditedLogs([]);
        setEnableCard(undefined);
      } else {
        message.error(
          response?.payload?.message ||
            'Update failed. Please try again or contact support.'
        );
      }
    } catch (err) {
      message.error('Update failed. Please try again.');
    } finally {
      setTruckShow(false);
    }
  };

  const handleEnable = (id, index, type, j, wip_id, i, fg_id) => {
    // Build the new editable-rows list from scratch — do NOT seed from `editedLogs`
    // right after `setEditedLogs([])`, because React batches state updates so the
    // local `editedLogs` is still the previous (un-cleared) array at this point.
    // That stale read was making the click appear to do nothing on the first try.
    const editableRows = [];
    if (type == 'main') {
      editableRows.push({
        blend_batch: null,
        blend_size: null,
        blend_bmr: null,
        blend_id: id
      });
    }
    if (type == 'wip') {
      editableRows.push({
        wip_batch: null,
        wip_strength: null,
        wip_bmr: null,
        wip_size: null,
        blend_alloc_wip: null,
        wip_size_caps: null,
        wip_id: wip_id,
        blend_id: id
      });
    }
    if (type == 'fg_batch') {
      editableRows.push({
        wip_batch: null,
        wip_strength: null,
        wip_bmr: null,
        wip_size: null,
        blend_alloc_wip: null,
        wip_size_caps: null,
        wip_id: wip_id,
        fg_id: fg_id,
        blend_id: id
      });
    }
    setEditedLogs(editableRows);
    setEnableCard({ id, index, type, sub_id: j, fg_id: i });
  };

  // Cancel: drop the edit buffer, close the edit-mode card, and re-fetch so
  // any visually-mutated `alllogs` values revert to the saved state.
  const handleCancel = () => {
    if (truckShow) return;
    setEditedLogs([]);
    setEnableCard(undefined);
    handleGetAllLogDetails();
  };

  // ── Discard / soft-delete flow ────────────────────────────────────────────
  // One-step cascade with a preview of what will be discarded. FG-level discard
  // is blocked at the row level when `has_invoice` is true (tooltip explains).
  // For Blend/WIP cascades the backend re-verifies the invoice rule atomically.
  // eslint-disable-next-line no-unused-vars
  const countCascade = (level, log, wipIdx, fgIdx) => {
    if (level === 'blend') {
      const wips = log?.wip_batch_nums || [];
      const fgs = wips.reduce(
        (sum, w) => sum + (w?.fg_batch_nums?.length || 0),
        0
      );
      return { wips: wips.length, fgs };
    }
    if (level === 'wip') {
      const fgs = log?.wip_batch_nums?.[wipIdx]?.fg_batch_nums?.length || 0;
      return { wips: 1, fgs };
    }
    return { wips: 0, fgs: 0 };
  };

  const confirmDiscard = (level, ids, log, wipIdx, fgIdx) => {
    if (truckShow) return;
    const { wips, fgs } = countCascade(level, log, wipIdx, fgIdx);
    let body;
    if (level === 'blend') {
      body = (
        <>
          <div>This will discard the Blend</div>
          {wips > 0 || fgs > 0 ? (
            <div style={{ marginTop: 8 }}>
              along with <b>{wips}</b> WIP{wips === 1 ? '' : 's'} and{' '}
              <b>{fgs}</b> FG pack{fgs === 1 ? '' : 's'} linked to it.
            </div>
          ) : null}
          <div style={{ marginTop: 8 }}>This action is logged.</div>
        </>
      );
    } else if (level === 'wip') {
      body = (
        <>
          <div>This will discard the WIP</div>
          {fgs > 0 ? (
            <div style={{ marginTop: 8 }}>
              along with <b>{fgs}</b> FG pack{fgs === 1 ? '' : 's'} linked to
              it.
            </div>
          ) : null}
          <div style={{ marginTop: 8 }}>This action is logged.</div>
        </>
      );
    } else {
      body = (
        <>
          <div>This will discard the FG pack.</div>
          <div style={{ marginTop: 8 }}>This action is logged.</div>
        </>
      );
    }
    Modal.confirm({
      title: 'Discard entry?',
      icon: <DeleteOutlined style={{ color: '#cf1322' }} />,
      content: body,
      okText: 'Discard',
      okButtonProps: { danger: true },
      cancelText: 'Cancel',
      onOk: async () => {
        await runDiscard(level, ids);
      }
    });
  };

  const runDiscard = async (level, ids) => {
    setTruckShow(true);
    try {
      const payload = { level, id: ids.id };
      const response = await dispatch(discardBatch(payload));
      if (response?.payload?.success) {
        message.success(
          response?.payload?.message || 'Discarded successfully.'
        );
        // If the BLEND itself was discarded, the page no longer has a record
        // to show — bounce back to the list. Otherwise re-fetch.
        if (level === 'blend') {
          history.push('/log-book-list');
        } else {
          handleGetAllLogDetails();
          setEditedLogs([]);
          setEnableCard(undefined);
        }
      } else {
        message.error(
          response?.payload?.message ||
            'Discard failed. Please try again or contact support.'
        );
      }
    } catch (err) {
      message.error('Discard failed. Please try again.');
    } finally {
      setTruckShow(false);
    }
  };

  // Render helper — Save+Cancel pair (used in card headers when in edit mode).
  const renderSaveCancel = () => (
    <Space size={4}>
      <Tooltip title="Save changes">
        <CustomButton
          type="primary"
          size="small"
          icon={<SaveOutlined />}
          onClick={handleUpdate}
          disabled={truckShow}
        >
          Save
        </CustomButton>
      </Tooltip>
      <Tooltip title="Discard unsaved changes">
        <CustomButton
          size="small"
          icon={<CloseOutlined />}
          onClick={handleCancel}
          disabled={truckShow}
        >
          Cancel
        </CustomButton>
      </Tooltip>
    </Space>
  );

  // Render helper — Edit + Discard pair (used in card headers in view mode).
  const renderEditDiscard = (level, onEdit, onDiscard, disabledReason) => {
    const editBtn = (
      <span
        role="button"
        tabIndex={0}
        aria-label="Edit"
        onClick={onEdit}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onEdit();
          }
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          cursor: 'pointer',
          borderRadius: 4,
          transition: 'background 0.15s'
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = '#fce4ec')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
      >
        <EditOutlined style={{ fontSize: 20, color: '#c91761' }} />
      </span>
    );
    const discardCore = (
      <span
        role="button"
        tabIndex={disabledReason ? -1 : 0}
        aria-label="Discard"
        aria-disabled={disabledReason ? 'true' : 'false'}
        onClick={disabledReason ? undefined : onDiscard}
        onKeyDown={(e) => {
          if (disabledReason) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onDiscard();
          }
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 36,
          height: 36,
          cursor: disabledReason ? 'not-allowed' : 'pointer',
          borderRadius: 4,
          transition: 'background 0.15s',
          opacity: disabledReason ? 0.4 : 1
        }}
        onMouseEnter={(e) => {
          if (!disabledReason) e.currentTarget.style.background = '#fff1f0';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
        }}
      >
        <DeleteOutlined style={{ fontSize: 20, color: '#cf1322' }} />
      </span>
    );
    const discardBtn = disabledReason ? (
      <Tooltip title={disabledReason}>{discardCore}</Tooltip>
    ) : (
      discardCore
    );
    return (
      <Space size={0}>
        {editBtn}
        {discardBtn}
      </Space>
    );
  };

  const handlePrint = () => {
    setHidePrint(true);
    const payload = { id: params.id };
    dispatch(printLogDetails(payload)).then((response) => {
      if (response?.payload?.success) {
        setHidePrint(false);
        // window.open(response?.payload?.url, '_blank');
        window.open(
          `${process.env.REACT_APP_STORAGE_URL}${response?.payload?.url
            .split('/')
            .pop()}`,
          '_blank'
        );
      }
    });
  };
  return (
    <Layout sider={false}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
      >
        {alllogs?.map((log, index) => {
          return (
            <Card
              title="VIEW BATCH NUMBERING LOG BOOK"
              className={styles.CustomPanel}
              key={index}
              extra={
                hidePrint ? (
                  <Spin />
                ) : (
                  <CustomButton type="primary" onClick={handlePrint}>
                    <FilePdfOutlined /> Print
                  </CustomButton>
                )
              }
            >
              <Card
                // className={styles.subpanel}
                title="BATCH NUMBERS"
                className={styles.CustomPanel}
                extra={
                  enableCard?.type === 'main' && enableCard?.id === log?.id
                    ? renderSaveCancel()
                    : renderEditDiscard(
                        'blend',
                        () => handleEnable(log?.id, index, 'main'),
                        () => confirmDiscard('blend', { id: log?.id }, log)
                      )
                }
              >
                <Row gutter={24}>
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Blend Batch"
                      rules={[
                        {
                          required: true,
                          message: 'Select Blend Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Enter Blend Batch"
                        value={log?.blend_batch}
                        disabled={enableCard?.type == 'main' ? false : true}
                        onChange={(e) =>
                          handleOnChange(
                            e,
                            log?.id,
                            index,
                            '_',
                            'blend_batch',
                            'main'
                          )
                        }
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Blend Size"
                      rules={[
                        {
                          required: true,
                          message: 'Enter blend size'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Enter Blend Size"
                        onChange={(e) =>
                          handleOnChange(
                            e,
                            log?.id,
                            index,
                            '_',
                            'blend_size',
                            'main'
                          )
                        }
                        value={log?.blend_size}
                        disabled={enableCard?.type == 'main' ? false : true}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="BMR"
                      rules={[
                        {
                          required: true,
                          message: 'Enter BMR'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Enter BMR"
                        value={log?.blend_bmr}
                        onChange={(e) =>
                          handleOnChange(
                            e,
                            log?.id,
                            index,
                            '_',
                            'blend_bmr',
                            'main'
                          )
                        }
                        disabled={enableCard?.type == 'main' ? false : true}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Alloted By"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Alloted By'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Enter Alloted By"
                        value={log?.alloted_by}
                        disabled
                      />
                    </FormItem>
                  </Col>
                </Row>
                {enableCard?.type == 'main' ? (
                  <FormItem className="text-center">
                    <Space>
                      {truckShow ? (
                        <Image
                          src={truck}
                          preview={false}
                          style={{ width: '100px !important', height: '100px' }}
                        />
                      ) : (
                        <CustomButton
                          type="primary"
                          onClick={() => handleUpdate(log?.id, index)}
                        >
                          Update
                        </CustomButton>
                      )}
                    </Space>
                  </FormItem>
                ) : (
                  ''
                )}
              </Card>
              {log?.wip_batch_nums?.map((item, j) => {
                return (
                  <Space size={6} key={j}>
                    <Card
                      // className={styles.subpanel}
                      className={styles.CustomPanel}
                      title="Compression/Coating/Capsulation Batch Details"
                      key={j}
                      extra={
                        enableCard?.type === 'wip' &&
                        enableCard?.id === log?.id &&
                        enableCard?.sub_id === j
                          ? renderSaveCancel()
                          : renderEditDiscard(
                              'wip',
                              () =>
                                handleEnable(log?.id, index, 'wip', j, item.id),
                              () =>
                                confirmDiscard('wip', { id: item.id }, log, j)
                            )
                      }
                    >
                      <Row gutter={24}>
                        <Col xs={24} xl={8} span={8} md={24} sm={24}>
                          <FormItem
                            label="WIP/Strength Batch #"
                            rules={[
                              {
                                required: true,
                                message: 'Enter WIP'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter WIP/Strength Batch"
                              value={item?.wip_batch}
                              disabled={
                                enableCard?.type == 'wip' &&
                                enableCard?.sub_id == j
                                  ? false
                                  : true
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  log?.id,
                                  index,
                                  j,
                                  'wip_batch',
                                  'wip',
                                  item?.id
                                )
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={8} span={8} md={24} sm={24}>
                          <FormItem
                            label="Strength"
                            rules={[
                              {
                                required: true,
                                message: 'Enter Strength'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter Strength"
                              value={item?.wip_strength}
                              disabled={
                                enableCard?.type == 'wip' &&
                                enableCard?.sub_id == j
                                  ? false
                                  : true
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  log?.id,
                                  index,
                                  j,
                                  'wip_strength',
                                  'wip',
                                  item?.id
                                )
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={8} span={8} md={24} sm={24}>
                          <FormItem
                            label="BMR #"
                            rules={[
                              {
                                required: true,
                                message: 'Enter BMR #'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter BMR #"
                              value={item?.wip_bmr}
                              disabled={
                                enableCard?.type == 'wip' &&
                                enableCard?.sub_id == j
                                  ? false
                                  : true
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  log?.id,
                                  index,
                                  j,
                                  'wip_bmr',
                                  'wip',
                                  item?.id
                                )
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={8} span={8} md={24} sm={24}>
                          <FormItem
                            label="WIP Size(KG)"
                            rules={[
                              {
                                required: true,
                                message: 'Enter WIP Size'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter WIP Size"
                              value={item?.wip_size}
                              disabled={
                                enableCard?.type == 'wip' &&
                                enableCard?.sub_id == j
                                  ? false
                                  : true
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  log?.id,
                                  index,
                                  j,
                                  'wip_size',
                                  'wip',
                                  item?.id
                                )
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={8} span={8} md={24} sm={24}>
                          <FormItem
                            label="Blend Allocation to WIP %"
                            rules={[
                              {
                                required: true,
                                message: 'Enter Blend Allocation'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter Blend Allocation to WIP"
                              value={item?.blend_alloc_wip}
                              disabled
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  log?.id,
                                  index,
                                  j,
                                  'blend_alloc_wip',
                                  'wip',
                                  item?.id
                                )
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={24} xl={8} span={8} md={24} sm={24}>
                          <FormItem
                            label="WIP Size Capsuals"
                            rules={[
                              {
                                required: true,
                                message: 'Enter WIP Size Capsuals'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter WIP Size Capsuals"
                              value={item?.wip_size_caps}
                              disabled={
                                enableCard?.type == 'wip' &&
                                enableCard?.sub_id == j
                                  ? false
                                  : true
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  e,
                                  log?.id,
                                  index,
                                  j,
                                  'wip_size_caps',
                                  'wip',
                                  item?.id
                                )
                              }
                            />
                          </FormItem>
                        </Col>
                      </Row>
                      {item?.fg_batch_nums?.map((packdata, i) => {
                        return (
                          <Space key={i} size={6}>
                            <Card
                              // className={styles.subpanel}
                              title="Packing/FG Details"
                              className={styles.CustomPanelFG}
                              key={i}
                              extra={
                                enableCard?.type === 'fg_batch' &&
                                enableCard?.id === log?.id &&
                                enableCard?.sub_id === j &&
                                enableCard?.fg_id === i
                                  ? renderSaveCancel()
                                  : renderEditDiscard(
                                      'fg',
                                      () =>
                                        handleEnable(
                                          log?.id,
                                          index,
                                          'fg_batch',
                                          j,
                                          item.id,
                                          i,
                                          packdata.id
                                        ),
                                      () =>
                                        confirmDiscard(
                                          'fg',
                                          { id: packdata.id },
                                          log,
                                          j,
                                          i
                                        ),
                                      packdata?.has_invoice
                                        ? `Cannot discard — invoice ${
                                            packdata?.invoice_num || ''
                                          } exists. Contact finance to void it first.`
                                        : null
                                    )
                              }
                            >
                              <Row gutter={24}>
                                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                                  <FormItem
                                    label="Packing/FG Batch #"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Enter Packing/FG Batch #'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter Packing/FG Batch #"
                                      value={packdata?.packing_fg_batch}
                                      disabled={
                                        enableCard?.type == 'fg_batch' &&
                                        enableCard?.sub_id == j &&
                                        enableCard?.fg_id == i
                                          ? false
                                          : true
                                      }
                                      onChange={(e) =>
                                        handleOnChange(
                                          e,
                                          log?.id,
                                          index,
                                          j,
                                          'packing_fg_batch',
                                          'fg',
                                          item?.id,
                                          i,
                                          packdata.id
                                        )
                                      }
                                    />
                                  </FormItem>
                                </Col>
                                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                                  <FormItem
                                    label="Count"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Enter Count'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter Count"
                                      value={packdata?.fg_count}
                                      disabled={
                                        enableCard?.type == 'fg_batch' &&
                                        enableCard?.sub_id == j &&
                                        enableCard?.fg_id == i
                                          ? false
                                          : true
                                      }
                                      onChange={(e) =>
                                        handleOnChange(
                                          e,
                                          log?.id,
                                          index,
                                          j,
                                          'fg_count',
                                          'fg',
                                          item?.id,
                                          i,
                                          packdata.id
                                        )
                                      }
                                    />
                                  </FormItem>
                                </Col>
                                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                                  <FormItem
                                    label="BPR #"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Enter BPR #'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter BPR #"
                                      value={packdata?.fg_bpr}
                                      disabled={
                                        enableCard?.type == 'fg_batch' &&
                                        enableCard?.sub_id == j &&
                                        enableCard?.fg_id == i
                                          ? false
                                          : true
                                      }
                                      onChange={(e) =>
                                        handleOnChange(
                                          e,
                                          log?.id,
                                          index,
                                          j,
                                          'fg_bpr',
                                          'fg',
                                          item?.id,
                                          i,
                                          packdata.id
                                        )
                                      }
                                    />
                                  </FormItem>
                                </Col>
                                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                                  <FormItem
                                    label="FG Allocated Capsuals"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Enter FG Allocated Capsuals'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter FG Allocated Capsuals"
                                      value={packdata?.fg_alloc_capsules}
                                      disabled={
                                        enableCard?.type == 'fg_batch' &&
                                        enableCard?.sub_id == j &&
                                        enableCard?.fg_id == i
                                          ? false
                                          : true
                                      }
                                      onChange={(e) =>
                                        handleOnChange(
                                          e,
                                          log?.id,
                                          index,
                                          j,
                                          'fg_alloc_capsules',
                                          'fg',
                                          item?.id,
                                          i,
                                          packdata.id
                                        )
                                      }
                                    />
                                  </FormItem>
                                </Col>
                                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                                  <FormItem
                                    label="Blend Allocation to FG %"
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          'Enter Blend Allocation to FG %'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter Blend Allocation to FG %"
                                      value={packdata?.blend_alloc_fg}
                                      disabled
                                      onChange={(e) =>
                                        handleOnChange(
                                          e,
                                          log?.id,
                                          index,
                                          j,
                                          'blend_alloc_fg',
                                          'fg',
                                          item?.id,
                                          i,
                                          packdata.id
                                        )
                                      }
                                    />
                                  </FormItem>
                                </Col>
                                <Col xs={24} xl={8} span={8} md={24} sm={24}>
                                  <FormItem
                                    label="WIP Allocation to FG %"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Enter WIP Allocation to FG %'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter WIP Allocation to FG %"
                                      value={packdata?.wip_alloc_fg}
                                      disabled
                                      onChange={(e) =>
                                        handleOnChange(
                                          e,
                                          log?.id,
                                          index,
                                          j,
                                          'wip_alloc_fg',
                                          'fg',
                                          item?.id,
                                          i,
                                          packdata.id
                                        )
                                      }
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                              {enableCard?.type == 'fg_batch' &&
                              enableCard?.sub_id == j &&
                              enableCard?.fg_id == i ? (
                                <FormItem className="text-center">
                                  <Space>
                                    {truckShow ? (
                                      <Image
                                        src={truck}
                                        preview={false}
                                        style={{
                                          width: '100px !important',
                                          height: '100px'
                                        }}
                                      />
                                    ) : (
                                      <CustomButton
                                        type="primary"
                                        onClick={() =>
                                          handleUpdate(log?.id, index)
                                        }
                                      >
                                        Update
                                      </CustomButton>
                                    )}
                                  </Space>
                                </FormItem>
                              ) : (
                                ''
                              )}
                            </Card>
                          </Space>
                        );
                      })}
                      <br />
                      <br />
                      {enableCard?.type == 'wip' && enableCard?.sub_id == j ? (
                        <FormItem className="text-center">
                          <Space>
                            {truckShow ? (
                              <Image
                                src={truck}
                                preview={false}
                                style={{
                                  width: '100px !important',
                                  height: '100px'
                                }}
                              />
                            ) : (
                              <CustomButton
                                type="primary"
                                onClick={() => handleUpdate(log?.id, index)}
                              >
                                Update
                              </CustomButton>
                            )}
                          </Space>
                        </FormItem>
                      ) : (
                        ''
                      )}
                    </Card>
                  </Space>
                );
              })}
            </Card>
          );
        })}

        <br />
        <FormItem className="text-center">
          <Space>
            <CustomButton htmlType="button" onClick={() => history.back()}>
              Cancel
            </CustomButton>
            {truckShow ? (
              <Image
                src={truck}
                preview={false}
                style={{ width: '100px !important', height: '100px' }}
              />
            ) : (
              ''
              // <CustomButton type="primary" htmlType="submit" loading={loading}>
              //   Submit
              // </CustomButton>
            )}
          </Space>
        </FormItem>
      </Form>
    </Layout>
  );
};
export default ViewEditLog;
